import React from "react";
import formatCurrency from "../../../../../../../../../utils/helpers/formatCurrency";

export default function RequestOrPaidInnerValue(props) {
  return (
    <div className="tw-space-y-1">
      <p className="tw-text-lg tw-font-medium tw-text-[#212121]">
        {/* N{String(props.value)} */}
        {formatCurrency(props.value ?? 0)}
      </p>
      <p className=" tw-text-sm tw-font-medium tw-text-[#1C1B1F] ">{String(props.type)}</p>
      <p className="tw-text-[10px] tw-font-medium tw-text-[#9E9E9E]">{String(props.additionalData)}</p>
    </div>
  );
}
